
export const marketingNav = [
    {url: '/marketing', label: 'Marketing', key: 'marketing.index', permissions: []},
]